import { Component } from '@angular/core';
import {TopBarComponent} from "../../top-bar/top-bar.component";
import {NavBarComponent} from "../nav-bar/nav-bar.component";
import {HeroAmbulanciaComponent} from "./hero-ambulancia/hero-ambulancia.component";
import {HowToAmbulanciaComponent} from "./how-to-ambulancia/how-to-ambulancia.component";
import {ServicesEnterprisesComponent} from "./services-enterprises/services-enterprises.component";
import {FooterPersonaComponent} from "../footer-persona/footer-persona.component";
import {FloatButtonComponent} from "../../float-button/float-button.component";

@Component({
  selector: 'app-ambulancia',
  standalone: true,
  imports: [
    TopBarComponent,
    NavBarComponent,
    HeroAmbulanciaComponent,
    HowToAmbulanciaComponent,
    ServicesEnterprisesComponent,
    FooterPersonaComponent,
    FloatButtonComponent
  ],
  templateUrl: './ambulancia.component.html',
  styleUrl: './ambulancia.component.css'
})
export class AmbulanciaComponent {

}
